export enum PUBLICATION_ORDER {
  /** seo index bu=y soe clicks */
  ORDER_SEO_INDEX = 'seo_index',
  /** The most recent publication comes first */
  ORDER_FRESHNESS = 'freshness',
  /** The oldest publication comes first */
  ORDER_OLDNESS = 'oldness',
  /** The drafts publications before all */
  ORDER_DRAFTS_FIRST = 'drafts_first',
  /** The publication with the biggest comments count comes first */
  ORDER_POPULARITY = 'popularity',
}

export enum PUBLICATION_FILTER {
  FILTER_PUBLISHED = 'published',
  FILTER_UNPUBLISHED = 'unpublished',
}

export enum PUBLICATION_CONTENT_TYPE {
  VIDEO = 'video',
  AUDIO = 'audio',
  READING = 'reading',
}
